<template>
  <div>
    <!-- <van-nav-bar
      title="利润分成明细"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/agency')"
    /> -->
    <van-list v-model="isLoading" @load="getDividedData" :finished="finished" finished-text="没有更多了" style="">
      <div v-for="(item,index) in dividedData" :key="index" class="agancyData">
      <van-row>
        <van-col span="8" style="color:grey;">
            {{ item.type }}
        </van-col>
        <van-col span="6">
            金额: {{ item.number }}
        </van-col>
        <van-col span="10" style="text-align:right;">
            余额: {{ item.balance }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
            账号：{{ item.capital_order }}
        </van-col>
        <van-col span="6">
            {{ item.user_name }}
        </van-col>
        <van-col span="10" style="text-align:right;color:grey;">
            {{ item.time }}
        </van-col>
      </van-row>
      <hr>
      </div>
      <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
    </van-list>
  </div>
</template>

<script>
    export default {
      name: "DividedCost",
      data(){
        return{
          dividedData:[],
          isLoading:false,
          finished:false,
          page:1,
          num:20
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getDividedData(){
          let that = this;
          let page = that.page;
          let num = that.num;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_commissioninfo",
                token: sessionStorage.getItem("token"),
                flag:'divided',
                num: num,
                page: page,
              }
            })
            .then(function (res) {
              let resData = res.data;
              let page = that.page;
              that.isLoading = false;
              if (res.data.code == 1) {
                that.page = page + 1;
                that.dividedData = that.dividedData.concat(resData.data);  
                if (resData.data.length < num){
                   that.finished = true;
                }
              } else if (res.data.code == 0) {
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(()=>{
              that.isLoading = false; 
              that.finished = true;
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })
        },
      },
      mounted:function () {
        let that = this;
        that.isLogin();
      }
    }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.agancyData{
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DividedCost.vue